// list
export const CLEAR_LIST = "list@CLEAR_LIST";

export const FETCH_LISTS_INIT = "list@FETCH_LISTS_INIT";
export const FETCH_LISTS_SUCCEDED = "list@FETCH_LISTS_SUCCEDED";
export const FETCH_LISTS_FAILED = "list@FETCH_LISTS_FAILED";

export const FETCH_LIST_INIT = "list@FETCH_LIST_INIT";
export const FETCH_LIST_SUCCEDED = "list@FETCH_LIST_SUCCEDED";
export const FETCH_LIST_FAILED = "list@FETCH_LIST_FAILED";

export const CREATE_LIST_EXTRA_DATA_INIT = "LIST@CREATE_LIST_EXTRA_DATA_INIT"
export const CREATE_LIST_EXTRA_DATA_SUCCEDED = "LIST@CREATE_LIST_EXTRA_DATA_SUCCEDED"
export const CREATE_LIST_EXTRA_DATA_FAILED = "LIST@CREATE_LIST_EXTRA_DATA_FAILED"

export const EDIT_LIST_INIT = "list@EDIT_LIST_INIT";
export const EDIT_LIST_SUCCEDED = "list@EDIT_LIST_SUCCEDED";
export const EDIT_LIST_FAILED = "list@EDIT_LIST_FAILED";

export const FETCH_LIST_CONTENT_INIT = "list@FETCH_LIST_CONTENT_INIT";
export const FETCH_LIST_CONTENT_SUCCEDED = "list@FETCH_LIST_CONTENT_SUCCEDED";
export const FETCH_LIST_CONTENT_FAILED = "list@FETCH_LIST_CONTENT_FAILED";

export const EDIT_LIST_CONTENT_INIT = "list@EDIT_LIST_CONTENT_INIT";
export const EDIT_LIST_CONTENT_SUCCEDED = "list@EDIT_LIST_CONTENT_SUCCEDED";
export const EDIT_LIST_CONTENT_FAILED = "list@EDIT_LIST_CONTENT_FAILED";

export const FETCH_LIST_EXTRA_DATA_INIT = "list@FETCH_LIST_EXTRA_DATA_INIT";
export const FETCH_LIST_EXTRA_DATA_SUCCEDED = "list@FETCH_LIST_EXTRA_DATA_SUCCEDED";
export const FETCH_LIST_EXTRA_DATA_FAILED = "list@FETCH_LIST_EXTRA_DATA_FAILED";

export const EDIT_LIST_EXTRA_DATA_INIT = "list@EDIT_LIST_EXTRA_DATA_INIT";
export const EDIT_LIST_EXTRA_DATA_SUCCEDED = "list@EDIT_LIST_EXTRA_DATA_SUCCEDED";
export const EDIT_LIST_EXTRA_DATA_FAILED = "list@EDIT_LIST_EXTRA_DATA_FAILED";

export const DELETE_LIST_INIT = "list@DELETE_LIST_INIT";
export const DELETE_LIST_SUCCEDED = "list@DELETE_LIST_SUCCEDED";
export const DELETE_LIST_FAILED = "list@DELETE_LIST_FAILED";


